
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[event]/check-in",
      function () {
        return require("private-next-pages/[event]/check-in.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[event]/check-in"])
      });
    }
  